import { buttonLink } from '@insify/css/classes.module.css';
import { Modal } from '@insify/design-system/components';
import { headingSm, textMd } from '@insify/design-system/typography';
import { TrackedButton } from '@objectiv/tracker-react';
import clsx from 'clsx';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { useCommands } from '../../../../../hooks/useCommands';
import { useParamsQuery } from '../../../../../hooks/useQueries';

import * as styles from './EmailSendNew.module.css';

export const EmailSendNew: React.FC = () => {
  const { t } = useTranslation(['funnel']);
  const { data } = useParamsQuery();
  const email = data?.representative?.email;

  const { sendCommand } = useCommands();
  const [isModalOpened, setIsModalOpened] = useState(false);

  const sendQuoteEmail = () => {
    void sendCommand({
      type: 'requestQuoteEmail',
      payload: {},
    });
  };

  return email ? (
    <>
      <TrackedButton
        type='button'
        objectiv={{ id: 'quote-email-receipt' }}
        data-testid='quote-email-receipt'
        onClick={() => setIsModalOpened(true)}
        className={buttonLink}
      >
        {t('checkout_overview_send_email_modal_link_label')}
      </TrackedButton>
      <Modal trackingId='quote-email-receipt-modal' open={isModalOpened} onClose={() => setIsModalOpened(false)}>
        <Trans
          className={headingSm}
          i18nKey='funnel:checkout_overview_send_email_modal_title'
          values={{ email }}
          parent='h2'
        />
        <Trans
          className={clsx(textMd, styles.description)}
          i18nKey='funnel:checkout_overview_send_email_modal_description'
          parent='p'
          components={{
            a: (
              <TrackedButton
                type='button'
                objectiv={{ id: 'quote-email-receipt-send' }}
                data-testid='quote-email-receipt-send'
                onClick={sendQuoteEmail}
                className={clsx(buttonLink, textMd, styles.quoteEmailSend)}
              />
            ),
          }}
        />
      </Modal>
    </>
  ) : null;
};
